import {KitBehaviour} from "../KitBehaviour";
import {ITask} from "./ITask"

export class TimerTask implements ITask {
    public AddOneTime(action: ()=>void, key: string): void {
        this.AddTask(0, action, key, 1);
    }

    public AddTask(interval: number, action: ()=>void, key: string, runCount: number): void {
        KitBehaviour._timer.SetTimer(key, action, runCount, interval,);
    }

    public RemoveTask(key: string): void {
        KitBehaviour._timer.clearTask(key);
    }

    public OnDestroy() {
    }

}